// extracted by mini-css-extract-plugin
export var chevronIcon = "_5n-2";
export var teamName = "_5n-1";
export var teamSwitcherButton = "_5n-0";